<template>
  <button
    type="button"
    class="btn mw-sm-184x btn btn-outline-secondary h-36x d-flex justify-content-center align-items-center size-12 w-15 rounded-5"
    @mouseenter="onHover(true)"
    @mouseleave="onHover(false)"
  >
    <img :src="currentIcon" />
    <span class="ms-2">{{ title }}</span>
  </button>
</template>

<script setup lang="ts">
import PLUS_ICON_URL from '@/assets/image/plus.svg';
import HOVER_PLUS_ICON_URL from '@/assets/image/icon-plus.svg';
import { ref } from 'vue';

const currentIcon = ref(PLUS_ICON_URL);

const onHover = (isHovered: boolean): void => {
  currentIcon.value = isHovered ? HOVER_PLUS_ICON_URL : PLUS_ICON_URL;
};

defineProps<{ title: string }>();
</script>
